import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "../../Pages/SideMenu";
import Footer from "../../Pages/Footer";
import Header from "../../Pages/Header";
import Logout from "../../Pages/Logout";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { GetApiHeaders } from "../../Utilities/NetworkUtilities";
//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import {
  openStock,
  getMasters,
  openStockDetails,
} from "../../Utilities/URLCONSTANTS";
// import {Oval as Loader} from 'react-loader-spinner';
import Loader from "../../Utilities/Loader";
// import ViewIcon from "../../images/viewIcon.png";
import ViewIcon from "../../images/view_icon.svg"
// import ViewIcon from "../../images/Eye_Icon.svg";
import moment from "moment";
import * as XLSX from "xlsx";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { customstyles } from "../../Utilities/utils";
import { customStyles } from "../../Utilities/utils";
import Select from "react-select";
import searchIcon from "../../images/search_icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from "../../Utilities/Pagination";

const OpenStock = () => {
  const [loaderImage, setLoaderImage] = useState(
    require("../../images/cs_loader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItemIndex, setSelectedItemIndex] = useState();
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [getData, setGetData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [getMasterLocation, setGetMasterLocation] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  //for data table
  const tableRef = useRef(null);
  useEffect(() => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    $(tableRef.current).DataTable({
      ordering: false,
    });
    fetchData();
    getMasterData();
  }, []);
  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };

  const handleModalOpen = (item, index) => {
    setShowModal(true);
    setSelectedItem(item);
    setSelectedItemIndex(index);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };
  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
  };


  const locationFilteredData = filteredData.filter((item) => {
    return selectedLocation === "" || item.productStoreLocation === selectedLocation;
  });

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  const pageNumbers = [];
  //
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    // for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const fetchData = async () => {
    const GetApi = openStock;
    const headers = await GetApiHeaders();
    try {
      setIsLoading(true);
      const response = await axios.get(GetApi, { headers });
      console.log("openStock", response);
      setData(response.data.response.openStock);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!data) return;
    let filtered = data;
    if (selectedLocation) {
      filtered = data.filter(
        (item) =>
          item.productStoreLocation?.trim().toLowerCase() ===
          selectedLocation.trim().toLowerCase()
      );
    }
    setFilteredData(filtered);
    setTotalItems(filtered.length);
    setCurrentPage(1);
  }, [data, selectedLocation]);


  const handleData = async (item) => {
    const DataApi = openStockDetails;
    const headers = await GetApiHeaders();
    const sendData = {
      productCategoryID: item.productCategoryID,
      productCategory: item.productCategory,
      productNameID: item.productNameID,
      productName: item.productName,
    };
    console.log(item);
    try {
      const responseData = await axios.post(DataApi, sendData, { headers });
      console.log("dataResponse", responseData.data);
      setGetData(responseData.data.response.openStock);
    } catch (error) {
      console.log(error);
    }
  };

  const getMasterData = async () => {
    const getData = getMasters;
    const headers = await GetApiHeaders();

    try {
      const responseGetData = await axios.post(getData, null, { headers });
      console.log("getmaster Data,", responseGetData);
      setGetMasterLocation(responseGetData.data.response.stockInwardLocations);
    } catch (err) {
      console.log("getError", err);
    }
  };

  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data && data.length > 0) {
      const filteredResults = data.filter((item) => {
        return (
          item.productName?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.productStoreLocation?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.inWardStock?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.issuedStock?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.balanceStock?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.productManufactureDate?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
      setFilteredData(filteredResults);
    }
  };

  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "Product Name",
        "Product Location",

        "Availability",
        "Issued",
        "Balance Stock",
        "Manufacture Date",
        "Expiry Date",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...locationFilteredData.map((item, index) => [
        index + 1,
        item.productName,
        item.productStoreLocation,
        item.inWardStock,
        item.issuedStock,
        item.balanceStock,
        item.productInDate,
        item.productExpiryDate,
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

    // Save the file
    XLSX.writeFile(wb, "openSotck.xlsx");
  };


  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      // Check if values are numeric
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
      }
      // Fallback for string comparison
      const aString = aValue?.toString().toLowerCase();
      const bString = bValue?.toString().toLowerCase();
      if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
      if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };

  const locationOptions =
    getMasterLocation?.map((item) => ({
      value: item.name,
      label: item.name,
    })) || [];


  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <h5 className="Roles_text">Central Store</h5>

                <div>
                  <h5 className="mb-2 Sub_role_text"> Open Stock</h5>
                </div>
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <div className="d-flex justify-content-between"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />
                        &nbsp;
                        <label> Entries</label>
                      </div>
                      <div className="d-flex align-items-center ">
                        {/* Search Input */}


                        <Select
                          styles={customStyles}
                          options={locationOptions}
                          placeholder="Select Location"
                          className="mb-2"
                          value={
                            locationOptions.find(
                              (option) => option.value === selectedLocation
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            setSelectedLocation(selectedOption?.value || "")
                          }
                          isClearable
                        />
                        &nbsp;&nbsp;

                        <div className="d-flex align-items-center">
                          <div className="search-container">
                            <img
                              src={searchIcon}
                              alt="Search"
                              className="search-icon"
                            />
                            <input
                              type="text"
                              placeholder="Type to Search..."
                              value={searchTerm}
                              onChange={(e) => handleFilter(e.target.value)}
                              className="search-input mr-2"
                            />
                            {searchTerm && (
                              <button
                                type="button"
                                className="search-clear-btn"
                                onClick={() => handleFilter("")}
                              >
                                ×
                              </button>
                            )}
                          </div>
                          &nbsp;
                          <button
                            className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                            onClick={exportToExcel}
                          >
                            Download Excel
                          </button>
                        </div>

                      </div>
                    </div>
                    <div>
                      <div
                        className="card data_tableCard mr-2 ml-1"
                      // style={{ width: "100%", overflowX: "auto" }}
                      >
                        <div className="card-body ">
                          <div className="table-responsive">
                            <Table className="table table-bordered table-bg Content_data_table table-striped">
                              <Thead>
                                <Tr>
                                  <Th className="text-center">S.No</Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("productName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Item Name
                                      {renderSortIcon("productName")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("productStoreLocation")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Location
                                      {renderSortIcon("productStoreLocation")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("inWardStock")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Availability
                                      {renderSortIcon("inWardStock")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("issuedStock")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Issued
                                      {renderSortIcon("issuedStock")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("balanceStock")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Balance
                                      {renderSortIcon("balanceStock")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("productManufactureDate")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      MFG Date
                                      {renderSortIcon("productManufactureDate")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center cursor-pointer"
                                    onClick={() => handleSort("productExpiryDate")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Expiry Date
                                      {renderSortIcon("productExpiryDate")}
                                    </span>
                                  </Th>
                                  <Th className="text-center">Actions</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {currentItems.length === 0 ? (
                                  <Tr>
                                    <Td colSpan={9} className="text-center">
                                      <span style={{ padding: 195 }}>Data is not available</span>
                                    </Td>
                                  </Tr>
                                ) : (
                                  currentItems.map((item, index) => {
                                    var newDateFormat = moment(item.productManufactureDate);
                                    if (newDateFormat.isValid()) {
                                      newDateFormat = newDateFormat.format("DD-MMM-YYYY");
                                    } else {
                                      newDateFormat = "";
                                    }

                                    var ExpiryDAte = moment(item.productExpiryDate);
                                    if (ExpiryDAte.isValid()) {
                                      ExpiryDAte = ExpiryDAte.format("DD-MMM-YYYY ")
                                    } else {
                                      ExpiryDAte = "";
                                    }
                                    return (
                                      <Tr key={index}>
                                        <Td className="text-left">{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                        <Td className="text-left">
                                          {item.productName}
                                        </Td>

                                        <Td className="text-left">
                                          {item.productStoreLocation}
                                        </Td>
                                        <Td className="text-left">
                                          {item.inWardStock}
                                        </Td>
                                        <Td className="text-left">
                                          {item.issuedStock}
                                        </Td>
                                        <Td className="text-left">
                                          {item.balanceStock}
                                        </Td>

                                        <Td className="text-center">
                                          {newDateFormat}{" "}
                                        </Td>
                                        <Td className="text-center">
                                          {ExpiryDAte}{" "}
                                        </Td>

                                        <Td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div onClick={() => handleData(item)}>
                                            <img
                                              src={ViewIcon}
                                              onClick={handleModalOpen}
                                              alt="viewIcon"
                                              style={{
                                                height: 10,
                                                cursor: "pointer",
                                                color: "#007AFF",
                                              }}
                                            />
                                          </div>
                                        </Td>
                                      </Tr>
                                    );
                                  })
                                )}
                              </Tbody>
                            </Table>
                          </div>
                        </div>
                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          totalItems={sortedData.length}
                          itemsPerPage={itemsPerPage}
                          currentItems={currentItems}
                          onPageChange={handlePageClick}
                        />
                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="xl"
                            style={{ marginLeft: -20 }}
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> Open Stock </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleClose}
                              >
                                X
                              </Button>
                            </Modal.Header>

                            <Modal.Body
                              className="pl-md-5 pr-md-5 pt-0"
                              style={{ overflowX: "auto", width: "100%" }}
                            >
                              <Table className="table table-bordered table-bg Content_data_table table-striped ">
                                <Thead>
                                  <Tr>
                                    <Th className="">S.No</Th>
                                    <Th
                                      className="item-name-cell"
                                      style={{
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      Item Name
                                    </Th>
                                    <Th className="">Batch No</Th>
                                    <Th className="">Invoice No</Th>
                                    <Th className="">Stock Inward</Th>
                                    {/* <Th className="">Balance</Th>
                                    <Th className="">Issued</Th> */}
                                    <Th className="">MFG Date</Th>
                                    <Th className="">Expiry Date</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {getData.length === 0 ? ( // Check if no data is found
                                    <Tr   >
                                      <Td colSpan={13} className="dataNotAvailable text-center"  >
                                        Data is not available
                                      </Td>
                                    </Tr>
                                  ) : (
                                    getData.map((item, getIndex) => {
                                      var newDateFormat = moment(
                                        item.productManufactureDate
                                      ).format("DD-MMM-YYYY ");
                                      var ExpiryDAte = moment(
                                        item.productExpiryDate
                                      ).format("DD-MMM-YYYY ");

                                      return (
                                        <Tr key={getIndex}>
                                          <Td>{getIndex + 1}</Td>
                                          <Td className="item-name-cell d-flex">
                                            {item.productName}
                                          </Td>
                                          <Td>{item.batchNumber}</Td>
                                          <Td>{item.productInvoiceNumber}</Td>
                                          <Td>{item.inWardStock}</Td>
                                          {/* <Td className="text-center">-</Td>
                                          <Td className="text-center">-</Td> */}
                                          <Td>{newDateFormat}</Td>
                                          <Td>{ExpiryDAte}</Td>
                                        </Tr>
                                      );
                                    })
                                  )}
                                </Tbody>
                              </Table>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                  {isLoading && (
                    <Loader
                      loading={isLoading}
                      message={"Fetching Data. Please Wait..!"}
                      loderimage={loaderImage}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};

export default OpenStock;
